import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Create a custom base query with global error handling
export const createBaseQueryWithAuth = (baseUrl) => {
  return async (args, api, extraOptions) => {
    const result = await fetchBaseQuery({
      baseUrl: baseUrl || (process.env.REACT_APP_API_URL || '/api'),
      prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.token;
        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }
        return headers;
      },
    })(args, api, extraOptions);

    // Handle 401 Unauthorized responses globally
    if (result.error && result.error.status === 401) {
      console.log('Token expired or invalid, clearing auth and redirecting to login');
      // Clear auth state
      api.dispatch({ type: 'auth/logout' });
      // Redirect to login
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
    }

    return result;
  };
};
